const getHighestRankingAward = (awards?: Array<{ sortOrder?: number; translation?: string }>) =>
    awards?.sort((a, b) => a.sortOrder - b.sortOrder)?.[0];

export default getHighestRankingAward;
